<template>
  <div class="simple-upload-container">
    <div v-if="zipFile != ''" >{{zipFile}}</div>
    <div class="total-progress" style="position: relative">
      <div  v-if="status == 'wait'">
        <el-upload

          class="upload-demo"
          drag
          action=""
          accept=".zip"
          name="add"
          :http-request="handleFileChange"
          :show-file-list="false"
          :before-upload="handleBefore"
        >
          <i class="el-icon-upload"></i>
          <div v-if="zipFile == ''" class="el-upload__text">将文件拖到此处，或<em>
            <!--点击上传-->
            点击上传</em>,只支持zip格式
          </div>
          <div v-else class="el-upload__text">将文件拖到此处，或<em>
            <!--点击上传-->
            点击更新</em>,只支持zip格式
          </div>
        </el-upload>
        <el-tooltip effect="light" placement="top-start">
          <div slot="content" class="tip-info">*重新上传应用后，点击页面右下角“更新”按钮,将会覆盖已上传的应用。<br/> 应用只支持共享模式,
            <el-link href="https://www.pingxingyun.com/contribute/detail?topicId=10071&categoryId=3" target="_blank" type="primary">点击查看详细要求</el-link></div>
          <i style=" position: absolute;left: 526px;top: 80px" class="el-icon-question tip-icon"></i>
        </el-tooltip>
      </div>

      <div v-else>
        <div class="item-info-size">{{ uploadFile.name}}</div>
        <el-progress :text-inside="true" :stroke-width="16" :width=400
                     :percentage="uploadPercent"></el-progress>
        <div class="item-info-size">
          <div style="float: left">
            <span style="width: 70px;display: inline-block">{{ sendRate | transformSendRate }}s</span>
            <span style="width: 150px;display: inline-block">{{ uploadFile.size *uploadPercent/100 | transformByte }}B/{{ uploadFile.size | transformByte }}B</span>
          </div>
          <div style="float: right;">
            <span v-if="status == 'success'"><i class="el-icon-success" style="color: #67C23A"></i>上传成功</span>
            <span v-else-if="status == 'unZiping'"><i class="el-icon-loading" style="color: #67C23A;"></i>解压中</span>
            <span v-else>{{ leftTime | secondsToDate }}</span>
          </div>
        </div>

      </div>


    </div>

  </div>
</template>

<script>
  import {saveObjArr, getObjArr, clearLocalStorage} from '@/utils/localstorage';
  import axios from 'axios'
  import {Message} from "element-ui";
  import Vue from 'vue'
  // 单个文件的状态
  const fileStatus = {
    wait: 'wait',
    uploading: 'uploading',
    success: 'success',
    error: 'error',
    secondPass: 'secondPass',
    pause: 'pause',
    resume: 'resume',
    unZiping: 'unZiping',
  };

  export default {
    name: 'SimpleUploaderContainer',
    props: {
      headers: {
        type: Object,
        default: null
      },
      // 文件个数
      limit: {
        type: Number,
        default: 0
      },
      // 文件超出个数限制时的钩子
      onExceed: {
        type: Function,
        default: () => {
        }
      },
      multiple: {
        type: Boolean,
        default: true
      },
      // 切片大小
      chunkSize: {
        type: Number,
        //default: 5 * 1024 * 1024
        default: 1  * 1024
      },
     // 应用
      zipFile: {
        type: String,
        default:""
      },
      // 上传并发数
      threads: {
        type: Number,
        default: 1
      },
      // 编辑应用时传递appliId
      appliId: {
        type: String,
        default: ""
      },

    },
    data: () => ({
      uploadFile: {},
      tempThreads: 3,
      // 默认状态
      status: fileStatus.wait,
      totalSize: 0,
      uploadPercent: 0,
      sendRate: 0,
      leftTime: 0,
      form:{
        exeFilePathList:[],
        appliPath:'',
        zipFile:'',
        fileSize:''
      },
      userLeftZipFileSize:0
    }),
    computed: {},
    destroyed() {
      // this.clearFiles();
    },
    created() {
      this.tempThreads = this.threads;
    },
    mounted() {
      this.getLeftZipFileSize()
    },
    methods: {
      handleFileChange(e) {
        const file = e.file;
        this.totalSize = e.file.size;
        //判断当前应用是否符合存储容量限制
        if(this.userLeftZipFileSize < this.totalSize) {
          //使用Vue.Filter()方式获取全局过滤器
          var te = Vue.filter('transformByte');
          Message.error("当前您剩余存储配额不足：最大可上传"+ te(this.userLeftZipFileSize ) +"B，可删除多余应用后继续使用");
          return;
        }
        if (!file) return;
        this.status = fileStatus.wait;
        this.handleStart(file);
      },
      handleStart(rawFile) {
        // 初始化部分自定义属性
        this.status = fileStatus.wait;
        rawFile.chunkList = [];
        this.uploadFile = rawFile;
        this.handleUpload()
      },
      async handleUpload() {
        var uploadId = '';
        await this.getUploadId().then(res => {
          uploadId = res
        })
        const fileChunkList = this.createFileChunk(this.uploadFile);
        this.status = fileStatus.uploading;
        this.uploadFile.chunkList = fileChunkList.map(({file}, index) => ({
          originalFilename: this.uploadFile.name,
          chunkIndex: index,
          chunk: file,
          chunkSize: file.size,
          totalSize: this.totalSize,
          totalChunkCnt: fileChunkList.length,
          uploadId: uploadId
          // hash: this.uploadFile.hash + '-' + index,
        }));
        await this.uploadChunks(this.uploadFile);

      },
      // 将切片传输给服务端
      async uploadChunks(data) {
        var chunkData = data.chunkList;
        return new Promise(async (resolve, reject) => {
          const requestDataList = chunkData
            .map(({chunkIndex, chunkSize, chunk, originalFilename, totalChunkCnt, totalSize, uploadId}) => {
              let formData = new FormData();
              formData.append('chunkIndex', chunkIndex);
              formData.append('chunkSize', chunkSize);
              formData.append('chunkStart', this.chunkSize * chunkIndex);
              formData.append('chunk', chunk);
              formData.append('originalFilename', originalFilename);
              formData.append('totalChunkCnt', totalChunkCnt);
              formData.append('totalSize', totalSize);
              formData.append('uploadId', uploadId);
              chunkIndex
              return {formData, chunkIndex, originalFilename};
            });
          try {
            const ret = await this.sendRequest(requestDataList, chunkData);
            if(ret == 'done'){
              this.status = fileStatus.success
            }
          } catch (error) {
            // 上传有被reject的
            this.$message.error('亲 上传失败了,考虑重试下呦' + error);
            return;
          }
        });
      },
      // 并发处理
      async sendRequest(forms, chunkData) {
        let finished = 0,retryCnt = 0,startTime = new Date().getTime();
        const total = forms.length;
        return new Promise((resolve, reject) => {
          const handler = async () => {

            if (forms.length) {
              //把数组的第一个元素从其中删除，并返回第一个元素的值。
              let formInfo = forms.shift();
              if (formInfo == undefined) {
                return false;
              }
              var that = this;
              let formData = formInfo.formData;
              const index = formInfo.chunkIndex;
              //当前时间戳
              //计算每片的平均速率，由于波动较大，先给注释掉
              //chunkData[index].startTime = new Date().getTime();
              axios({
                method: 'post', url: this.$larkXRUrl + '/appli/sliceUpload', data: formData,
                // `onUploadProgress` 允许为上传处理进度事件
                onUploadProgress: function (progressEvent) {
                  // 对原生进度事件的处理
                  // that.createProgresshandler(that.uploadFile)
                },
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'authorization': that.$store.state.user ? that.$store.state.user.token : null
                }
              })
            /*  this.postMultipartRequest('/poc/hostAppli/sliceUpload', formData)*/
            .then((res) => {
                if(res != undefined && res.data != undefined &&res.data.code == 1000){
                  // 更改状态
                 /* chunkData[index].uploaded = true;
                  chunkData[index].status = 'success';*/
                  // 存储已上传的切片下标
                  this.addChunkStorage(chunkData[index].uploadId, index);
                  finished++;
                  this.uploadPercent = parseInt((finished / total).toFixed(2) * 100);
                  let endTime = new Date().getTime();
                  let chunkStorage = this.getChunkStorage(chunkData[index].uploadId);
                  let chunkStorageLength = chunkStorage ? chunkStorage.length: 0;
                  let diff = endTime - startTime,unzipFlag = (chunkStorageLength  == total-1 && res.data.result.isUnzipEnable);
                  if(finished < total){
                    this.sendRate = this.uploadPercent /100 * this.totalSize / diff * 1000;
                    this.leftTime = this.totalSize * (100 - this.uploadPercent)/100 / this.sendRate
                  }
                  //判断最后一片是否属于解压阶段、
                  if(unzipFlag){
                    //显示解压中
                    this.uploadPercent = 100
                    this.status = fileStatus.unZiping
                    clearLocalStorage(chunkData[index].uploadId);
                  }
                  if (chunkStorageLength >= total || res.data.result.completeType == 1) {
                    this.form.appliPath = res.data.result.appliPath;
                    this.form.zipFile = res.data.result.zipFilePath;
                    this.form.fileSize = this.uploadFile.size;
                    this.form.exeFilePathList =  res.data.result.exeFilePathList ? res.data.result.exeFilePathList : [];
                    resolve('done');
                  } else {
                      handler();
                  }
                }else {
                  //有可能解压出错，也有可能某一片出错
                  //某一片出错时加一个重传机制
                  retryCnt++
                  if(retryCnt < 10){
                    console.log('出现错误', res.data.message);
                    forms.push(formInfo);
                  }else {
                    this.$message(res.data.message)
                    this.status = fileStatus.wait;
                  }
                }
              }).catch((e) => {
                console.log('/appli/sliceUpload error',e)
           /*     this.tempThreads++; // 释放当前占用的通道
                // 将失败的重新加入队列
                forms.push(formInfo);*/
              });
            }

          };
          if (finished >= total) {
            resolve('done');
          }else {
            //总共剩下多少片
            let left = total - finished;
            let tempThreads = left < this.tempThreads ? left : this.tempThreads
            for (let i = 0; i < tempThreads; i++) {
              handler();
            }
          }
        });
      },
      // 获取上传ID
      getUploadId() {
        return new Promise((resolve, reject) => {
          //this.getRequest("/poc/hostAppli/getUploadId", {}, {
          axios({
            method: 'get', url: this.$larkXRUrl + '/appli/getUploadId', data: {},
            // `onUploadProgress` 允许为上传处理进度事件
            onUploadProgress: function (progressEvent) {
              // 对原生进度事件的处理
              // that.createProgresshandler(that.uploadFile)
            },
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
              'authorization': this.$store.state.user ? this.$store.state.user.token : null
            }
          }).

          then((res) => {
            console.log(res)
            if (res.data.code === 1000) {
              resolve(res.data.result);
            } else {
              resolve('');
            }
          }).catch((err) => {
            console.log('mergeRequest -> err', err);
            reject();
          });
        });
      },

      // 创建文件切片
      createFileChunk(file, size = this.chunkSize) {
        const fileChunkList = [];
        var count = 0;
        while (count < file.size) {
          fileChunkList.push({
            file: file.slice(count, count + size)
          });
          count += size;
        }
        return fileChunkList;
      },

      // 切片上传进度
      createProgresshandler(item) {
        // item.uploadPercent = parseInt(String((p.loaded / p.total) * 100));
        //this.fileProgress();
      },
      // 存储已上传完成的切片下标
      addChunkStorage(name, index) {
        const data = [index];
        const arr = getObjArr(name);
        if (arr) {
          saveObjArr(name, [...arr, ...data]);
        } else {
          saveObjArr(name, data);
        }
      },
      // 获取已上传完成的切片下标
      getChunkStorage(name) {
        return getObjArr(name);
      },
      handleBefore(file) {
        this.$emit('beforeUpload',file);
      },

      getLeftZipFileSize:function () {
        console.log(this.appliId)
        var params = {};
        if(this.appliId != ""){
          params.appliId = this.appliId;
        }
        this.getRequest('/pocAppli/getLeftZipFileSize', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.userLeftZipFileSize = resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      }
    },
    watch: {
      status() {
        if(this.status == fileStatus.success){
          this.$emit('success', this.form);
        }

      },
    }
  };
</script>
<style>
.el-progress-bar .el-progress-bar__inner .el-progress-bar__innerText {
  vertical-align: top!important;
  margin: 2px 5px!important;
}
</style>
